import _extends from 'babel-runtime/helpers/extends';

export default {
  name: 'svg-icon',

  props: {
    iconClass: {
      type: String,
      required: true
    },
    className: {
      type: String
    },
    // icon 大小，宽高都使用该值
    size: {
      type: Number
    },
    color: {
      type: String
    },
    hoverColor: {
      type: String
    }
  },

  computed: {
    iconName: function iconName() {
      return '#icon-' + this.iconClass;
    },
    svgClass: function svgClass() {
      if (this.className) {
        return 'svg-icon ' + this.className;
      }
      return 'svg-icon';
    },
    innerStyle: function innerStyle() {
      var style = {};
      if (this.size) {
        style = _extends({}, style, {
          width: this.size + 'px',
          height: this.size + 'px'
        });
      }
      if (this.color) {
        style = _extends({}, style, {
          fill: this.color
        });
      }
      return style;
    }
  }
};